/* eslint-disable camelcase */
import { fetchOembed } from '@wix/ricos-common';
import { VIDEO_TYPE } from 'wix-rich-content-common';
export default function videoThumbnailStrategy(instance, hasPlugin) {
    if (!instance || !hasPlugin(VIDEO_TYPE))
        return {};
    return {
        helpers: {
            onVideoSelected: function (url, updateEntity) {
                return typeof url === 'string'
                    ? fetchOembed(url, instance)
                        .then(function (oembed) {
                        var thumbnail_url = oembed.thumbnail_url, thumbnail_height = oembed.thumbnail_height, thumbnail_width = oembed.thumbnail_width;
                        return { thumbnail_url: thumbnail_url, thumbnail_height: thumbnail_height, thumbnail_width: thumbnail_width, video_url: url };
                    })
                        .then(function (oembed) { return updateEntity({ oembed: oembed }); })
                        .catch(function () { return updateEntity({ oembed: null }); })
                    : Promise.resolve(updateEntity({ oembed: null }));
            },
        },
    };
}
//# sourceMappingURL=videoThumbnailStrategy.js.map